import { forwardRef } from "react";
import useNewMessagingEnabled from "@src/features/messaging/posts/useNewMessagingEnabled";
import MessageOutlineIcon from "@src/lib/icons/18px/message-outline";
import MsgsOutlineIcon from "@src/lib/icons/18px/msgs-outline";
import { IconProps } from "@src/lib/icons/types";

const MessageActionIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const Icon = useNewMessagingEnabled() ? MsgsOutlineIcon : MessageOutlineIcon;
  return <Icon {...props} ref={ref} />;
});
MessageActionIcon.displayName = "MessageActionIcon";

export default MessageActionIcon;
